<template>
  <section
    v-if="shipment_detail"
    :key="countRq"
    class="shipment-detail-van px-1"
  >
    <validation-observer ref="requestSubmit">
      <!-- Order Information -->
      <div class="title pt-1 pb-1">Customer Information</div>
      <b-card class="b-card-bg">
        <b-row class="px-2">
          <b-col lg="12">
            <b-row>
              <b-col cols="12" lg="4">
                <validation-provider #default="{ errors }" rules="">
                  <b-form-group>
                    <label class="custom-label-shipment">Service type</label>
                    <Select2
                      :disabled="true"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      placeholder="Select Service Type"
                      v-model="shipment_detail.service_type"
                      :options="service_types"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group>
                  <label class="custom-label-shipment">Order ID</label>
                  <b-form-input :disabled="true" v-model="bookingId" />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="12">
            <b-row>
              <b-col cols="12" lg="4">
                <validation-provider
                  name="Company name"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label class="custom-label-shipment">Company name </label>

                    <Select4
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      class="select2-v2"
                      rules="required"
                      :disabled="true"
                      placeholder="Enter your customer's name"
                      v-model="shipment_detail.customer_company_id"
                      :options="{
                        isSearch: true,
                        value: 'code',
                        label: 'text',
                        data: company_list,
                        fields: [
                          {
                            field: 'name',
                            label: 'Company name',
                          },
                        ],
                      }"
                    />

                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="4">
                <validation-provider
                  name="Company address"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label class="custom-label-shipment flex"
                      >Company address
                    </label>

                    <Select4
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      class="select2-v2"
                      placeholder="Enter your customer's address"
                      v-model="companyAddress"
                      :disabled="true"
                      :options="{
                        isSearch: true,
                        value: 'address',
                        label: 'address',
                        data: company_list,
                        fields: [
                          {
                            field: 'address',
                            label: 'Company address',
                          },
                        ],
                      }"
                    />
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="4">
                <validation-provider
                  name="Tax code"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label class="custom-label-shipment flex">Tax code</label>

                    <Select4
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      class="select2-v2"
                      :disabled="true"
                      placeholder="Enter your customer's tax code"
                      v-model="companyTax"
                      :options="{
                        isSearch: true,
                        value: 'code',
                        label: 'tax_code',
                        data: company_list,
                        fields: [
                          {
                            field: 'code',
                            label: 'Tax Code',
                          },
                        ],
                      }"
                    />
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="12">
            <b-row>
              <b-col cols="12" lg="2" class="pr-0">
                <validation-provider #default="{ errors }" rules="">
                  <b-form-group>
                    <label class="custom-label-shipment"
                      >To whom will booking be released?
                    </label>
                    <!-- <b-form-input
                    :state="errors.length > 0 ? false : null"
                    v-model="shipment_on_tms.customer_name"
                    placeholder="Customer Contact"
                  /> -->
                    <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="true"
                      placeholder="Select Customer"
                      v-model="shipment_detail.customer_id"
                      :options="customer_list_options"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="2" class="pt-custom">
                <validation-provider
                  name="Phone"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="true"
                      v-model="shipment_detail.customer_phone"
                      placeholder="Phone"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="4">
                <validation-provider
                  name="Email"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label class="custom-label-shipment">Email </label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="true"
                      v-model="shipment_detail.customer_email"
                      placeholder="Email"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </b-col>

          <b-col>
            <b-row>
              <b-col cols="12" lg="2" class="pr-0">
                <validation-provider
                  name="Contact WR1"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label class="custom-label-shipment">WR1's PIC </label>

                    <Select2
                      :disabled="true"
                      v-model="shipment_detail.sale_id"
                      :options="sales"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="2" class="pt-custom">
                <validation-provider
                  name="Phone"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="true"
                      v-model="shipment_detail.sale_phone"
                      placeholder="Phone"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="4">
                <validation-provider
                  name="Email"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label class="custom-label-shipment">Email </label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="true"
                      v-model="shipment_detail.sale_email"
                      placeholder="Email"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <!-- END Order Information -->
      <div class="title pt-1 pb-1">Routing Details</div>
      <b-card class="b-card-bg pt-1 pb-1">
        <b-row class="px-2">
          <b-col cols="12" lg="4">
            <validation-provider
              name="Quotation No."
              #default="{ errors }"
              rules=""
            >
              <b-form-group>
                <label class="custom-label-shipment">Quotation No.</label>
                <Select4
                  :disabled="true"
                  class="select2-v2"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Quotation No."
                  v-model="shipment_detail.quotation"
                  :options="{
                    isSearch: true,
                    value: 'id',
                    label: 'id',
                    data: quotations,
                    fields: [
                      {
                        field: 'id',
                        label: 'Quotation No.',
                      },
                      {
                        field: 'exp_date',
                        label: 'Valid to',
                      },
                      {
                        field: 'total_cost',
                        label: 'Total cost',
                      },
                    ],
                  }"
                />

                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col lg="2"></b-col>
          <b-col lg="4"
            ><validation-provider
              name="Handling type"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label class="custom-label-shipment flex"
                  >Handling type
                  <div class="red">*</div></label
                >
                <Select4
                  :disabled="true"
                  class="select2-v2"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Select Handling type"
                  v-model="shipment_detail.shippingType"
                  :options="{
                    value: 'id',
                    label: 'name',
                    data: transport_types,
                    fields: [
                      {
                        field: 'name',
                        label: 'Type',
                      },
                    ],
                  }"
                />

                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider></b-col
          >
        </b-row>
        <b-row class="px-2 mt-1">
          <b-col>
            <b-row>
              <b-col lg="10">
                <validation-provider
                  name="Pick up address"
                  #default="{ errors }"
                  rules="required"
                  v-if="!shipment_detail.isPickUpInput"
                >
                  <b-form-group>
                    <label class="custom-label-shipment flex"
                      >Pick up address
                      <span class="red">*</span>
                    </label>

                    <Select4
                      v-model="shipment_detail.pickup_location"
                      placeholder="Enter a previously used pick up address, or click OTHER to in put a new one"
                      :disabled="true"
                      :options="{
                        isSearch: true,
                        value: 'id',
                        label: 'text',
                        data: locations,
                        fields: [
                          {
                            field: 'abbreviations',
                            label: 'Abbreviations',
                          },
                          {
                            field: 'name',
                            label: 'Location',
                          },
                          {
                            field: 'address',
                            label: 'Address',
                          },
                        ],
                      }"
                    />
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
                <validation-provider
                  name="Pick up address"
                  #default="{ errors }"
                  rules="required"
                  v-if="shipment_detail.isPickUpInput"
                >
                  <b-form-group>
                    <label class="custom-label-shipment flex"
                      >Pick up address

                      <span class="red">*</span>
                    </label>

                    <b-form-input
                      :disabled="true"
                      class="iuput"
                      v-model="shipment_detail.valuePickupInput"
                      type="text"
                      placeholder="Enter a previously used pick up address, or click OTHER to in put a new one"
                    ></b-form-input>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col lg="2" class="pt-custom"
                ><div class="container-checkbox">
                  <input
                    :disabled="true"
                    type="checkbox"
                    class="custom-checkbox-new"
                    v-model="shipment_detail.isPickUpInput"
                  />

                  <div>
                    <div class="text-black">Other</div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row>
              <b-col lg="10">
                <validation-provider
                  name="Delivery address"
                  #default="{ errors }"
                  rules="required"
                  v-if="!shipment_detail.isAddressInput"
                >
                  <b-form-group>
                    <label class="custom-label-shipment flex"
                      >Delivery address
                      <span class="red">*</span>
                    </label>

                    <Select4
                      v-model="shipment_detail.delivery_location"
                      placeholder="Enter a previously used delivery address, or click OTHER to in put a new one"
                      :disabled="true"
                      :options="{
                        isSearch: true,
                        value: 'id',
                        label: 'text',
                        data: locations,
                        fields: [
                          {
                            field: 'abbreviations',
                            label: 'Abbreviations',
                          },
                          {
                            field: 'name',
                            label: 'Location',
                          },
                          {
                            field: 'address',
                            label: 'Address',
                          },
                        ],
                      }"
                    />
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
                <validation-provider
                  name="Delivery address"
                  #default="{ errors }"
                  rules="required"
                  v-if="shipment_detail.isAddressInput"
                >
                  <b-form-group>
                    <label class="custom-label-shipment flex"
                      >Delivery address <span class="red">*</span></label
                    >

                    <b-form-input
                      :disabled="true"
                      class="iuput"
                      v-model="shipment_detail.valueAddressInput"
                      type="text"
                      placeholder="Enter a previously used delivery address, or click OTHER to in put a new one"
                    ></b-form-input>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col lg="2" class="pt-custom">
                <div class="container-checkbox">
                  <input
                    :disabled="true"
                    type="checkbox"
                    class="custom-checkbox-new"
                    v-model="shipment_detail.isAddressInput"
                  />

                  <div>
                    <div class="text-black">Other</div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="px-2 mt-1">
          <b-col lg="4">
            <b-row class="px-1"
              ><label class="custom-label-shipment"
                >Pick up contact person</label
              ></b-row
            >
            <b-row>
              <b-col class="pr-0">
                <b-form-input
                  :disabled="readonly"
                  class="iuput"
                  v-model="shipment_detail.pickUpContact.name"
                  type="text"
                  placeholder="Name"
                ></b-form-input>
              </b-col>
              <b-col>
                <b-form-input
                  :disabled="readonly"
                  class="iuput"
                  v-model="shipment_detail.pickUpContact.phone"
                  type="text"
                  placeholder="phone"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="2"></b-col>
          <b-col lg="4">
            <b-row class="px-1">
              <label class="custom-label-shipment"
                >Delivery contact person</label
              >
            </b-row>
            <b-row>
              <b-col class="pr-0">
                <b-form-input
                  :disabled="readonly"
                  class="iuput"
                  v-model="shipment_detail.deliveryContact.name"
                  type="text"
                  placeholder="Name"
                ></b-form-input>
              </b-col>
              <b-col>
                <b-form-input
                  :disabled="readonly"
                  class="iuput"
                  v-model="shipment_detail.deliveryContact.phone"
                  type="text"
                  placeholder="Phone"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="px-2 mt-2">
          <b-col lg="4">
            <label class="custom-label-shipment">Pick up date</label>
            <b-row>
              <b-col class="pr-0">
                <date-picker
                  :disabled="readonly"
                  ref="datePicker"
                  v-model="shipment_detail.pickUpDate"
                  type="date"
                  title-format="DD/MM/YY"
                  time-title-format="DD/MM/YY"
                  placeholder="Select date"
                  format="DD/MM/YY"
                  class="w-full"
                  value-type="format"
                >
                </date-picker>
              </b-col>
              <b-col>
                <date-picker
                  :disabled="readonly"
                  v-model="shipment_detail.pickUpTime"
                  ref="datePicker"
                  type="time"
                  title-format="HH:mm"
                  time-title-format="HH:mm"
                  placeholder="Select time"
                  format="HH:mm"
                  class="w-full"
                  value-type="format"
                >
                </date-picker>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="2"></b-col>
          <b-col lg="4">
            <label class="custom-label-shipment">Delivery date</label>
            <b-row>
              <b-col class="pr-0">
                <date-picker
                  :disabled="readonly"
                  ref="datePicker"
                  v-model="shipment_detail.deliveryDate"
                  type="date"
                  title-format="DD/MM/YY"
                  time-title-format="DD/MM/YY"
                  placeholder="Select date"
                  format="DD/MM/YY"
                  class="w-full"
                  value-type="format"
                >
                </date-picker>
              </b-col>
              <b-col>
                <date-picker
                  :disabled="readonly"
                  v-model="shipment_detail.deliveryTime"
                  ref="datePicker"
                  type="time"
                  title-format="HH:mm"
                  time-title-format="HH:mm"
                  placeholder="Select time"
                  format="HH:mm"
                  class="w-full"
                  value-type="format"
                >
                </date-picker>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="px-2 mt-2">
          <b-col lg="4">
            <label class="custom-label-shipment">Payment terms</label>
            <Select2
              :disabled="readonly"
              placeholder="Payment Terms"
              v-model="shipment_detail.paymentTerms"
              :options="$Options.paymentTerms"
            />
          </b-col>
        </b-row>
        
      </b-card>
      <div class="title pt-1 pb-1">Cargo Details</div>
      <b-card class="b-card-bg">
        <b-row class="mb-2">
          <b-col lg="3">
            <label class="custom-label-shipment">Booking No.</label>
            <b-form-input
              :disabled="readonly"
              class="iuput"
              v-model="shipment_detail.cargo_booking"
              placeholder="Enter Booking No."
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row
          v-for="vanContainer in shipment_detail.valueVan"
          :key="vanContainer.id"
          class="mt-1"
        >
          <b-col lg="3">
            <validation-provider
              name="Container Type"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label class="flex"
                  >Truck Type
                  <div class="red">*</div></label
                >
                <Select2
                  :class="errors.length > 0 ? 'is-invalid mb-1' : null"
                  :disabled="readonly"
                  :settings="{
                    allowClear: true,
                  }"
                  placeholder="Truck Type"
                  v-model="vanContainer.truck_type"
                  :options="cont_types.filter((i) => i.group === 'van truck')"
                />
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col lg="3">
            <validation-provider
              name="Quantity"
              #default="{ errors }"
              rules="required|minNumber:0"
            >
              <b-form-group>
                <label class="flex"
                  >Quantity
                  <div class="red">*</div>
                </label>
                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  :disabled="readonly"
                  @input="updateVanLine3(vanContainer)"
                  class="iuput"
                  v-model="vanContainer.quantity"
                  type="text"
                  placeholder="Quantity"
                  required
                ></b-form-input>
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col lg="3">
            <validation-provider
              name="Commodity Type"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label class="flex"
                  >Commodity Type
                  <div class="red">*</div></label
                >
                <Select2
                  :disabled="readonly"
                  placeholder="Select Commodity type"
                  v-model="vanContainer.commodity_type"
                  :options="goods_types"
                />
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- <select-view v-model="vanContainer.vanLine3" selectOptions /> -->

          <b-col class="mt-20-custom" v-if="!readonly">
            <div v-if="!vanContainer.hasDelete" class="custom-add-line">
              <b-img
                width="30px"
                @click="handleAddContainer"
                :src="iconAdd"
                alt="logo"
              />
            </div>

            <div v-if="vanContainer.hasDelete" class="custom-delete">
              <b-img
                width="30px"
                @click="handleDeleteVanContainer(vanContainer.id)"
                :src="remove"
                alt="logo"
              />
            </div>
          </b-col>
          <b-col lg="12">
            <b-row
              v-for="itemLine3 in vanContainer.vanLine3"
              :key="itemLine3.id"
              class="mt-1"
            >
              <!-- {{ itemLine3 }} -->

              <b-col cols="12" lg="2">
                <b-form-group>
                  <label class="custom-label-shipment">Truck Id</label>
                  <b-form-input
                    placeholder="TruckId."
                    disabled
                    v-model="itemLine3.truckId"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="3">
                <b-form-group>
                  <label class="custom-label-shipment flex"
                    >Pick up address
                    <span class="red">*</span>
                  </label>

                  <Select4
                    v-model="itemLine3.pickup_location"
                    :disabled="true"
                    :options="{
                      isSearch: true,
                      value: 'id',
                      label: 'text',
                      data: locations,
                      fields: [
                        {
                          field: 'abbreviations',
                          label: 'Abbreviations',
                        },
                        {
                          field: 'name',
                          label: 'Location',
                        },
                        {
                          field: 'address',
                          label: 'Address',
                        },
                      ],
                    }"
                  />
                </b-form-group>
              </b-col>
              <b-col lg="2">
                <label class="custom-label-shipment">Pick up date</label>

                <b-form-group>
                  <b-form-input disabled v-model="itemLine3.pickup_date" />
                </b-form-group>
              </b-col>

              <b-col lg="3">
                <b-form-group>
                  <label class="custom-label-shipment flex"
                    >Delivery address
                    <span class="red">*</span>
                  </label>

                  <Select4
                    v-model="itemLine3.delivery_location"
                    :disabled="true"
                    :options="{
                      isSearch: true,
                      value: 'id',
                      label: 'text',
                      data: locations,
                      fields: [
                        {
                          field: 'abbreviations',
                          label: 'Abbreviations',
                        },
                        {
                          field: 'name',
                          label: 'Location',
                        },
                        {
                          field: 'address',
                          label: 'Address',
                        },
                      ],
                    }"
                  />
                </b-form-group>
              </b-col>

              <b-col lg="2">
                <label class="custom-label-shipment">Delivery date</label>

                <b-form-group>
                  <b-form-input disabled v-model="itemLine3.delivery_date" />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col lg="12">
            <b-row
              v-for="itemVanLine in vanContainer.VanLine"
              :key="itemVanLine.id"
              class="mt-1"
            >
              <b-col lg="2">
                <validation-provider
                  name="Commodity"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label class="flex"
                      >Commodity
                      <div class="red">*</div>
                    </label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      class="iuput"
                      v-model="itemVanLine.commodity"
                      type="text"
                      placeholder="Commodity"
                      required
                    ></b-form-input>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col >
                <validation-provider
                  name="Total packages"
                  #default="{ errors }"
                  rules="required|minNumber:0"
                >
                  <b-form-group>
                    <label class="flex"
                      >Total packages
                      <div class="red">*</div>
                    </label>
                    <cleave
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      :options="$Utils.CONSTANTS.cleaveNumeral"
                      v-model="itemVanLine.total_package"
                      class="form-control"
                      placeholder="Total packages"
                      required
                    />
              
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col class="custom-grid">
                <validation-provider
                  name="Package type"
                  #default="{ errors }"
                  rule="required"
                >
                  <b-form-group>
                    <label class="flex"
                      >Package type
                      <div class="red">*</div></label
                    >

                    <Select2
                      :disabled="readonly"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      placeholder="Package type"
                      v-model="itemVanLine.package_type"
                      :options="
                        cont_types.filter((i) => i.group === 'packaging')
                      "
                    />
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col class="custom-grid">
                      <label>Dimension (cm)</label>

                      <div class="flex">
                        <validation-provider
                          name="Dimension"
                          #default="{ errors }"
                          rules="minNumber:0"
                        >
                          <b-form-group>
                            <b-form-input
                              :disabled="readonly"
                              class="iuput"
                              v-model="itemVanLine.dimension.lenght"
                              type="number"
                              placeholder="L (cm)"
                              required
                            ></b-form-input>

                            <small
                              class="text-danger"
                              v-show="errors.length > 0"
                              >{{ errors[0] }}</small
                            >
                          </b-form-group>
                        </validation-provider>

                        <validation-provider
                          name="Dimension"
                          #default="{ errors }"
                          rules="minNumber:0"
                        >
                          <b-form-group>
                            <b-form-input
                              :disabled="readonly"
                              class="iuput"
                              v-model="itemVanLine.dimension.width"
                              type="number"
                              placeholder="W (cm)"
                              required
                            ></b-form-input>
                            <small
                              class="text-danger"
                              v-show="errors.length > 0"
                              >{{ errors[0] }}</small
                            >
                          </b-form-group>
                        </validation-provider>
                        <validation-provider
                          name="Dimension"
                          #default="{ errors }"
                          rules="minNumber:0"
                        >
                          <b-form-group>
                            <b-form-input
                              :disabled="readonly"
                              class="iuput"
                              v-model="itemVanLine.dimension.height"
                              type="number"
                              placeholder="H (cm)"
                              required
                            ></b-form-input>
                            <small
                              class="text-danger"
                              v-show="errors.length > 0"
                              >{{ errors[0] }}</small
                            >
                          </b-form-group>
                        </validation-provider>
                      </div>
                    </b-col>
              
              <b-col lg="2">
                <validation-provider
                  name="Total gross weight (Kgs)"
                  #default="{ errors }"
                  rules="required|minNumber:0"
                >
                  <b-form-group>
                    <label class="flex"
                      >Total gross weight (Kgs)
                      <div class="red">*</div>
                    </label>
                    <cleave
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      :options="$Utils.CONSTANTS.cleaveNumeral"
                      v-model="itemVanLine.total_gross_weight"
                      class="form-control"
                      placeholder="Total gross weight (Kgs)"
                      required
                    />
                 
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col lg="2">
                <validation-provider
                  name="Total volume (cbm)"
                  #default="{ errors }"
                  rules="minNumber:0"
                >
                  <b-form-group>
                    <label class="flex">Total volume (cbm) </label>
                    <cleave
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      :options="$Utils.CONSTANTS.cleaveNumeral"
                      v-model="itemVanLine.total_volume"
                      class="form-control"
                      placeholder="Total volume (cbm)"
                      required
                    />
                 
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col lg="0.5" class="mt-20-custom">
                <div
                  v-if="!itemVanLine.hasDelete && !readonly"
                  @click="handleAddLineVan(vanContainer.id)"
                  class="custom-add-line"
                >
                  <b-img width="30px" :src="iconAdd" alt="logo" />
                </div>
                <div
                  v-if="itemVanLine.hasDelete && !readonly"
                  class="custom-delete"
                >
                  <b-img
                    width="30px"
                    @click="
                      handleDeleteLineVan(vanContainer.id, itemVanLine.id)
                    "
                    :src="remove"
                    alt="logo"
                  />
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <div class="title pt-1 pb-1">Additional Service</div>
      <b-card class="b-card-bg">
        <b-row>
          <div class="custom-additional">
            <input
              :key="reload"
              :disabled="readonly"
              type="checkbox"
              class="custom-checkbox-new"
              v-model="shipment_detail.has_customs"
              @change="() => this.reload++"
            />
            <div>Customs services</div>
          </div>
        </b-row>
        <div v-if="shipment_detail.has_customs" class="title custom-title mt-1">
          Customs Declaration
        </div>
        <b-row v-if="shipment_detail.has_customs">
          <b-col lg="3">
            <b-row>
              <b-col>
                <label class="custom-label-shipment">Customs type</label>
                <Select2
                  :disabled="readonly"
                  placeholder="Enter customs type"
                  v-model="shipment_detail.customs_type"
                  :options="customs_types"
                  v-if="!shipment_detail.has_other_custom"
                />
                <b-form-input
                  :disabled="readonly"
                  class="iuput"
                  v-model="shipment_detail.additional_custom_input"
                  type="text"
                  v-if="shipment_detail.has_other_custom"
                  placeholder="Enter customs type"
                  required
                ></b-form-input>
              </b-col>
              <b-col lg="0.5" class="mt-25">
                <div class="custom-container-other">
                  <input
                    :disabled="readonly"
                    type="checkbox"
                    class="custom-checkbox-new"
                    v-model="shipment_detail.has_other_custom"
                  />
                  <div>Other</div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="1"></b-col>
          <b-col lg="3">
            <label class="custom-label-shipment">
              Place of Custom declaration</label
            >

            <b-form-input
              :disabled="readonly"
              class="iuput"
              v-model="shipment_detail.place_of_custom"
              type="text"
              placeholder=" Place of Custom declaration"
              required
            ></b-form-input>
          </b-col>
          <b-col lg="1"></b-col>
          <b-col lg="3">
            <label class="custom-label-shipment">HS Code</label>

            <b-form-input
              :disabled="readonly"
              class="iuput"
              v-model="shipment_detail.HS_code_truck"
              type="text"
              placeholder="HS Code"
              required
            ></b-form-input>
          </b-col>
        </b-row>
      </b-card>
      <div class="title pt-1 pb-1">Notes</div>
      <b-card class="b-card-bg-notes">
        <b-form-textarea
          :disabled="readonly"
          class="textarea"
          v-model="shipment_detail.notes_truck"
          placeholder="Notes"
          required
        ></b-form-textarea>
      </b-card>
    </validation-observer>
  </section>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Select2 from "v-select2-component";

import moment from "moment";
import { mapState } from "vuex";
import mixins from "./mixin/mixin";
import { BFormGroup, BRow, BCol, BCard } from "bootstrap-vue";
export default {
  mixins: [mixins],

  props: [
    "request_quotation",
    "shipment_on_tms",
    "shipment_on_fast",
    "bookingId",
    "shipment_details",
  ],
  components: {
    ValidationProvider,
    Select2,
    ValidationObserver,
    BFormGroup,
    BRow,
    BCol,
    BCard,
  },
  // props: {
  //       request_quotation: { default: null },
  //       bookingId:{default:null}
  //   },
  computed: {
    ...mapState("masterData", [
      "ports",
      "cont_types",
      "goods_types",
      "transport_types",
      "regions",
      "deports_locations",
      "service_types",
      "business_types",
      "customs_types",
      "incoterms",
      "sales",
      "companyItems",
      "regions",
      "company_list",
      "shipping_lines",
      "customer_list_options",
      "handed_types",
      "quotations",
      "locations",
    ]),
    company_list() {
      return this.companyItems;
    },
    readonly() {
      return this.shipment_on_tms
        ? true
        : (this.request_quotation && this.request_quotation.accept_edit != 1) ||
            this.request_quotation.locked == 1 ||
            this.userData.userType ==
              this.$Utils.CONSTANTS.USER_TYPE_O.Client ||
            this.userData.userType ==
              this.$Utils.CONSTANTS.USER_TYPE_O.Client_Root ||
            this.request_quotation.status_id == 63;
    },
  },
  data() {
    return {
      checkFirst: false,
      iconAdd: require("@/assets/images/icons/add.png"),
      remove: require("@/assets/images/icons/remove.png"),
      reload: 1,
      companyAddress: null,
      companyTax: null,
      userData: JSON.parse(localStorage.getItem("userData")),
      showTimePanel: false,
      showTimeRangePanel: false,
      isHideShow: false,
      isHideShowPk: false,
      maxFiles: false,
      isHideShowBookingEdit: false,
      isHideShowPkBookingEdit: false,
      check_country_pick_up: null,
      check_country_delivery: null,
      shipment_detail: {
        id: null,
        pick_up_date: null,
        delivery_date: null,
        pickUpContact: {
          name: "",
        },
        deliveryContact: {
          name: "",
        },
      },

      useLocations: [],
      moment,
    };
  },
  watch: {
    "shipment_detail.valueVan": function (n, o) {
      if (o == null && !this.checkFirst) {
        this.shipment_detail.valueVan.forEach((element, index) => {
          element.orderDetailId = this.bookingId + this.pad(index + 1);

          element.vanLine3 = Array.from(
            { length: element?.quantity },
            (_, idx1) => ({
              truckId: element.orderDetailId + this.pad(idx1 + 1),
              pickup_location: element.pickup_location,
              pickup_date: element.pickUpdate,
              delivery_location: element.delivery_location,
              delivery_date: element.deliveryDate,

            })
          );
          element?.VanLine?.[0]?.commodity_type
            ? (element.commodity_type = element?.VanLine?.[0]?.commodity_type)
            : null;
          element?.VanLine?.forEach((item, ix) => {
            item.orderBlockId = element.orderDetailId + this.pad(ix + 1);

            if (!item?.dimension) {
              item.dimension = {};
              item.dimension.lenght = "";
              item.dimension.width = "";
              item.dimension.height = "";
            }
          });
        });
      }
    },
  },
  mounted() {
    this.$loading.show();
    console.log("VAN")
    if (this.request_quotation || this.shipment_details) {
      this.getUserLocation(this.request_quotation.customer_id);
      console.log(!this.isBlank(this.shipment_details))
      if (!this.isBlank(this.shipment_details)) {

        console.log(!this.isBlank(this.shipment_details))

        this.shipment_detail = this.shipment_details;
        if (!this.shipment_detail.has_customs) {
          this.shipment_detail.has_customs = this.request_quotation.has_customs;
        }
        if (!this.shipment_detail.customs_type) {
          this.shipment_detail.customs_type =
            this.request_quotation.customs_type;
        }
        if (!this.shipment_detail.custom_service_other) {
          this.shipment_detail.custom_service_other =
            this.request_quotation.custom_service_other;
        }
        if (!this.shipment_detail.customs_type_input) {
          this.shipment_detail.customs_type_input =
            this.request_quotation.customs_type_input;
        }
        if (!this.shipment_detail.HS_code_truck) {
          this.shipment_detail.HS_code_truck =
            this.request_quotation.HS_code_truck;
        }
        if (!this.shipment_detail.cargo_details_commodity_truck) {
          this.shipment_detail.cargo_details_commodity_truck =
            this.request_quotation.cargo_details_commodity_truck;
        }
        if (!this.shipment_detail.cargo_details_container_truck) {
          this.shipment_detail.cargo_details_container_truck =
            this.request_quotation.cargo_details_container_truck;
        }
        if (!this.shipment_detail.pickUpContact) {
          this.shipment_detail.pickUpContact =
            this.request_quotation.pickUpContact;
        }
        if (!this.shipment_detail.deliveryContact) {
          this.shipment_detail.deliveryContact =
            this.request_quotation.deliveryContact;
        }
        if (!this.shipment_detail.pickUpDate) {
          this.shipment_detail.pickUpDate = this.request_quotation.pickUpDate;
        }
        if (!this.shipment_detail.pickUpTime) {
          this.shipment_detail.pickUpTime = this.request_quotation.pickUpTime;
        }
        if (!this.shipment_detail.notes_truck) {
          this.shipment_detail.notes_truck = this.request_quotation.notes_truck;
        }
        if (!this.shipment_detail?.valueVan) {
          this.shipment_detail.valueVan = this.request_quotation.valueVan;
          this.checkFirst = false;
        } else {
          this.checkFirst = true;
        }
        this.shipment_detail.id = this.bookingId;
      } else {
        this.shipment_detail = this.request_quotation;
        this.shipment_detail.id = this.bookingId;
        this.shipment_detail.agent = this.shipment_on_fast?.agent;

        this.shipment_detail.service_type = this.request_quotation.service_type;
        this.shipment_detail.has_customs =
          this.request_quotation?.has_customs || false;
        this.shipment_detail.shippingType =
          this.request_quotation?.shippingType;
        // this.shipment_detail.files = this.request_quotation.files;

        this.shipment_detail.deport = this.request_quotation.deport;

        this.shipment_detail.cont_type = this.request_quotation.cont_type;

        this.shipment_detail.goods_type = this.request_quotation.goods_type;

        this.shipment_detail.trong_luong = this.request_quotation.trong_luong;

        this.shipment_detail.shipping_line =
          this.request_quotation.shipping_line;

        this.shipment_detail.BL =
          (this.request_quotation.shipment_info &&
            this.request_quotation.shipment_info.find((e) => e.id == "4.1")
              ?.hbl) ||
          "";

        this.shipment_detail.container_no = this.request_quotation.container_no;

        this.shipment_detail.seal_no = this.request_quotation.seal_no;

        this.shipment_detail.business_type =
          this.request_quotation.business_type;

        this.shipment_detail.customs_addr = this.request_quotation.customs_addr;

        this.shipment_detail.hs_code = this.request_quotation.hs_code;

        this.shipment_detail.notes = this.request_quotation.notes;

        this.shipment_detail.billingInformation =
          this.request_quotation.billingInformation;
        this.shipment_detail.so_luong = this.request_quotation.so_luong;
        this.shipment_detail.customs_type = this.request_quotation.customs_type;

        this.shipment_detail.pickup_location =
          this.request_quotation.pickup_location;
        this.shipment_detail.delivery_location =
          this.request_quotation.delivery_location;

        this.shipment_detail.shipper = this.shipment_on_fast?.shipper;
        this.shipment_detail.shipper_name = this.shipment_on_fast?.shipper_name;
        this.shipment_detail.consignee = this.shipment_on_fast?.consignee;
        this.shipment_detail.consignee_name =
          this.shipment_on_fast?.consignee_name;
        this.shipment_detail.vessel = this.shipment_on_fast?.vessel;
        this.shipment_detail.voyage = this.shipment_on_fast?.voyage;

        this.shipment_detail.placeOfDelivery =
          this.shipment_on_fast?.placeOfDelivery;

        this.shipment_detail.customer_id = this.request_quotation.customer_id;
        this.shipment_detail.customer_name =
          this.request_quotation.customer_name;
        this.shipment_detail.customer_phone =
          this.request_quotation.customer_phone;
        this.shipment_detail.customer_email =
          this.request_quotation.customer_email;

        this.shipment_detail.sale_id = this.request_quotation.sale_id;
        this.shipment_detail.sale_name = this.request_quotation.sale_name;
        this.shipment_detail.sale_phone = this.request_quotation.sale_phone;

        this.shipment_detail.sale_email = this.request_quotation.sale_email;
        this.shipment_detail.customer_company_id =
          this.request_quotation.company_id;
        this.shipment_detail.pick_up_date = this.request_quotation.pick_up_date;
        this.shipment_detail.delivery_date =
          this.request_quotation.delivery_date;

        this.shipment_detail.PICPickUp = this.request_quotation.PICPickUp;
        this.shipment_detail.PICDelivery = this.request_quotation.PICDelivery;
        this.shipment_detail.pol_port = this.request_quotation.pol_port;

        this.shipment_detail.pod_port = this.request_quotation.pod_port;
        this.shipment_detail.paymentTerms = this.request_quotation.paymentTerms;
        this.shipment_detail.cargo_ready = this.request_quotation.cargo_ready;

        this.shipment_detail.etd = this.request_quotation.etd;
        this.shipment_detail.eta = this.request_quotation.eta;
        this.shipment_detail.placeOfDelivery =
          this.request_quotation.placeOfDelivery;

        this.shipment_detail.placeOfReceipt =
          this.request_quotation.placeOfReceipt;
        this.shipment_detail.mo_ta = this.request_quotation.mo_ta;

        this.shipment_detail.so_khoi = this.request_quotation.so_khoi;
        this.shipment_detail.handled_type = this.request_quotation.handled_type;

        this.shipment_detail.dimension = this.request_quotation.dimension;

        this.shipment_detail.package_type = this.request_quotation.package_type;

        this.shipment_detail.packageNumber =
          this.request_quotation.packageNumber;
        this.shipment_detail.HBL = this.request_quotation.HBL
          ? this.request_quotation.HBL
          : "";
        this.shipment_detail.has_van_trucking =
          this.request_quotation.has_van_trucking;

        console.log(this.shipment_detail)

        // tao orderID
        this.shipment_detail.valueVan.forEach((element, index) => {
          element.orderDetailId = this.bookingId + this.pad(index + 1);

          element.vanLine3 = Array.from(
            { length: element?.quantity },
            (_, idx1) => ({
              truckId: element.orderDetailId + this.pad(idx1 + 1),
              pickup_location: element.pickup_location,
              pickup_date: element.pickUpdate,
              delivery_location: element.delivery_location,
              delivery_date: element.deliveryDate,

            })
          );
          element?.VanLine?.[0]?.commodity_type
            ? (element.commodity_type = element?.VanLine?.[0]?.commodity_type)
            : null;
          element?.VanLine?.forEach((item, ix) => {
            item.orderBlockId = element.orderDetailId + this.pad(ix + 1);

            if (!item?.dimension) {
              item.dimension = {};
              item.dimension.lenght = "";
              item.dimension.width = "";
              item.dimension.height = "";
            }
          });
        });
      }
    }
    if (
      this.shipment_detail &&
      this.company_list &&
      this.company_list.length > 0
    ) {
      const customerCompany = this.company_list.find(
        (item) => item.id === this.shipment_detail.customer_company_id
      );

      if (customerCompany) {
        this.companyAddress = customerCompany.address;
        this.companyTax = customerCompany.tax_code;
        this.reload++;
      } else {
        // Xử lý khi không tìm thấy đối tượng khớp với customer_company_id
        this.companyAddress = "";
        this.companyTax = "";
      }
    } else {
      // Xử lý khi shipment_detail hoặc company_list rỗng
      this.companyAddress = "";
      this.companyTax = "";
    }

    this.$store.commit("masterData/SET_SHIPPING_DETAIL", this.shipment_detail);
  },
  methods: {
    updateVanLine3(payload) {
      this.shipment_detail.valueVan.forEach((element) => {
        element.vanLine3 = Array.from(
          { length: element?.quantity },
          (_, idx) => ({
            truckId: element?.orderDetailId + this.pad(idx + 1),
            pickup_location: element.pickup_location,
            pickup_date: element.pickUpdate,
            delivery_location: element.delivery_location,
            delivery_date: element.deliveryDate,
            
          })
        );
      });
    },
    handleAddContainer() {
      const randomID =
        Math.random().toString(36).substr(2, 9) + "-" + Date.now();
      const randomID2 =
        Math.random().toString(30).substr(1, 8) + "-" + Date.now();
      const newElement = {
        id: randomID,
        hasDelete: true,
        truck_type: null,
        quantity: null,
        commodity_type: null,
        orderDetailId:
          this.bookingId + this.pad(this.shipment_detail.valueVan.length + 1),
        vanLine3: [],
        VanLine: [
          {
            id: randomID2,
            hasDelete: false,
            commodity: null,
            total_gross_weight: null,
            total_package: null,
            total_volume: null,

            dimension: {
              length: null,
              width: null,
              height: null,
            },
            orderBlockId:
              this.bookingId +
              this.pad(this.shipment_detail.valueVan.length + 1) +
              this.pad(1),
          },
        ],
      };
      this.shipment_detail.valueVan.push(newElement);
    },
    handleDeleteVanContainer(id) {
      this.shipment_detail.valueVan = this.shipment_detail.valueVan.filter(
        (item) => item.id !== id
      );
    },
    handleAddLineVan(id) {
      const randomID =
        Math.random().toString(36).substr(2, 9) + "-" + Date.now();
      const index = this.shipment_detail.valueVan.findIndex(
        (item) => item.id === id
      );
      if (index !== -1) {
        this.shipment_detail.valueVan[index].VanLine.push({
          id: randomID,
          hasDelete: true,
          commodity: null,
          total_gross_weight: null,
          total_package: null,
          total_volume: null,
          orderBlockId:
            this.bookingId +
            this.pad(index + 1) +
            this.pad(this.shipment_detail.valueVan[index].VanLine.length + 1),
          dimension: {
            length: null,
            width: null,
            height: null,
          },
        });
      }
    },
    handleDeleteLineVan(id, id2) {
      for (let i = 0; i < this.shipment_detail.valueVan.length; i++) {
        const currentObj = this.shipment_detail.valueVan[i];
        if (currentObj.id === id) {
          currentObj.VanLine = currentObj.VanLine.filter(
            (item) => item.id !== id2
          );
        }
      }
    },
    disabledRangeDelivery: function (date) {
      if (this.shipment_detail.pick_up_date) {
        var mydate = moment(this.shipment_detail.pick_up_date, "DD/MM/YYYY");

        //format that date into a different format
        var now = moment(mydate).format("MM/DD/YYYY");

        return date < new Date(now);
      }
    },
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleCloseChange() {
      this.$refs.datePicker.popupVisible = false;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    handleRangeClose() {
      this.showTimeRangePanel = false;
    },
    hideShows: function () {
      this.isHideShow = !this.isHideShow;
    },
    hideShowsPk: function () {
      this.isHideShowPk = !this.isHideShowPk;
    },
    changeHideShows: function () {
      this.isHideShowBookingEdit = !this.isHideShowBookingEdit;
    },
    changeHideShowsPk: function () {
      this.isHideShowPkBookingEdit = !this.isHideShowPkBookingEdit;
    },
  },
};
</script>

<style lang="scss">
label {
  font-weight: 600;
  color: #000000;
}
.custom-container-other {
  display: flex;
  align-items: center;
  gap: 5px;
  div {
    font-weight: 600;
    color: #000000;
  }
}
.shipment-detail-van {
  .custom-grid {
    flex: 0 0 19.5%;
    max-width: 19.3%;
    @media (max-width: 992px) {
      flex: 0 0 50%;
      max-width: 50%;
      margin: 0 0px;
    }
    .flex {
      display: flex;
      gap: 5px;
    }
  }
  .select2-selection--single:before {
    top: 13px;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAmElEQVQokZ3SwQ3CIBTG8X+7gI6BNzawq3jnoOyBMcEBOooj1BNXV3ACzDOSGEuL8CWEvPeR34lOebcFRkDulD31uQNDF2Nkdz1r4AZsGiDJE9DB2EcvUzB2Ev1TtGCDYDL0aduIJmxKi/67rURn2AysRI+/WBb8Ez0EY8dckQUL6CK2Ci6gpzXsHfmHpaO808q7S/FtjLwAmwh101zduSgAAAAASUVORK5CYII=") !important;
  }
  .flex {
    display: flex;
  }
  .custom-label-shipment {
    font-size: 1rem;
    color: #000000;
    font-weight: 600;
  }
  .b-card-bg-notes {
    border-radius: 1rem;
    background-color: white;
    height: auto;
    padding: 1.5rem;
    @media (max-width: 992px) {
      height: 350px;
    }
  }
  .pt-custom {
    padding-top: 1.75rem;
  }
  .custom-additional {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-left: 15px;
    div {
      color: #000000;
      font-size: medium;
      font-weight: 600;
    }
  }
  .mt-25 {
    margin-top: 28px !important;
  }
  & .form-control {
    border: none !important;
  }
  & .select2-container--default .select2-selection--single {
    border: none;
  }
  & .mx-input {
    border: none;
  }

  .select2 {
    height: 28px !important;
  }
  .mt-20-custom {
    margin-top: 1.8rem;
  }
  .custom-add-line {
    cursor: pointer;
  }
  .custom-delete {
    cursor: pointer;
  }
}
</style>
